// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickNumberInput_numberInputContainer__BAmXP {
  --foreground-color: var(--foreground-color-1);
  --background-color: var(--background-color-1);
  --border-radius: 0.25rem;
  --border-size: 2px;
  --focus-color: var(--blackAlpha);
  color: var(--foreground-color);
}
.ClickNumberInput_numberInputContainer__BAmXP.ClickNumberInput_dark__igX-y {
  --foreground-color: var(--background-color-1);
  --background-color: var(--foreground-color-1);
  --focus-color: var(--whiteAlpha);
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_numberInputWrapper__oOKJL {
  display: inline-block;
  width: 100%;
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_numberInputWrapper__oOKJL > .ClickNumberInput_numberInput__asTMZ {
  font-size: 1em;
  border-radius: var(--border-radius);
  border: solid var(--border-size) var(--foreground-color);
  background: var(--background-color);
  color: var(--foreground-color);
  width: 100%;
  padding: 0.25em 0.5em;
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_numberInputWrapper__oOKJL > .ClickNumberInput_numberInput__asTMZ::placeholder {
  color: var(--gray);
  font-style: italic;
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_numberInputWrapper__oOKJL > .ClickNumberInput_numberInput__asTMZ.ClickNumberInput_noStyle__DHwWM {
  border: none;
  background: none;
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_numberInputWrapper__oOKJL > .ClickNumberInput_numberInput__asTMZ.ClickNumberInput_noStyle__DHwWM:focus {
  outline: none;
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_numberInputWrapper__oOKJL > .ClickNumberInput_numberInput__asTMZ:focus {
  outline: none;
  border-color: var(--blue);
}
.ClickNumberInput_numberInputContainer__BAmXP label {
  font-weight: var(--bold);
}
.ClickNumberInput_numberInputContainer__BAmXP .ClickNumberInput_helpText__X-BvT {
  display: block;
  font-size: 0.75em;
  padding-bottom: 0.25em;
}

.ClickNumberInput_errorMessage__gSxTK {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickNumberInput.module.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,6CAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,8BAAA;AAAF;AAEE;EACE,6CAAA;EACA,6CAAA;EACA,gCAAA;AAAJ;AAEE;EACE,qBAAA;EACA,WAAA;AAAJ;AACI;EACE,cAAA;EACA,mCAAA;EACA,wDAAA;EACA,mCAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AACN;AAAM;EACE,kBAAA;EACA,kBAAA;AAER;AAAM;EACE,YAAA;EACA,gBAAA;AAER;AAAQ;EACE,aAAA;AAEV;AACM;EACE,aAAA;EACA,yBAAA;AACR;AAIE;EACE,wBAAA;AAFJ;AAIE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AAFJ;;AAKA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAFF","sourcesContent":[".numberInputContainer {\n  --foreground-color: var(--foreground-color-1);\n  --background-color: var(--background-color-1);\n  --border-radius: 0.25rem;\n  --border-size: 2px;\n  --focus-color: var(--blackAlpha);\n\n  color: var(--foreground-color);\n\n  &.dark {\n    --foreground-color: var(--background-color-1);\n    --background-color: var(--foreground-color-1);\n    --focus-color: var(--whiteAlpha);\n  }\n  .numberInputWrapper {\n    display: inline-block;\n    width: 100%;\n    > .numberInput {\n      font-size: 1em;\n      border-radius: var(--border-radius);\n      border: solid var(--border-size) var(--foreground-color);\n      background: var(--background-color);\n      color: var(--foreground-color);\n      width: 100%;\n      padding: 0.25em 0.5em;\n      &::placeholder {\n        color: var(--gray);\n        font-style: italic;\n      }\n      &.noStyle {\n        border: none;\n        background: none;\n\n        &:focus {\n          outline: none;\n        }\n      }\n      &:focus {\n        outline: none;\n        border-color: var(--blue);\n      }\n    }\n  }\n\n  label {\n    font-weight: var(--bold);\n  }\n  .helpText {\n    display: block;\n    font-size: 0.75em;\n    padding-bottom: 0.25em;\n  }\n}\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numberInputContainer": `ClickNumberInput_numberInputContainer__BAmXP`,
	"dark": `ClickNumberInput_dark__igX-y`,
	"numberInputWrapper": `ClickNumberInput_numberInputWrapper__oOKJL`,
	"numberInput": `ClickNumberInput_numberInput__asTMZ`,
	"noStyle": `ClickNumberInput_noStyle__DHwWM`,
	"helpText": `ClickNumberInput_helpText__X-BvT`,
	"errorMessage": `ClickNumberInput_errorMessage__gSxTK`
};
export default ___CSS_LOADER_EXPORT___;
